import { StyleSheet, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width } = Dimensions.get('window');

export const cardWidth = (width - (12.4 + 16.6)) / 1.22;

export default StyleSheet.create({
  containerStyle: theme => ({
    width: cardWidth,
    flex: 0,
    backgroundColor: theme.colors.backgroundColor,
    marginRight: 12.4,
    borderRadius: 6.2,
    paddingHorizontal: 16.4,
    paddingBottom: 16.1,
    marginBottom: 15,
    marginTop: 30,
    ...(theme.isDark
      ? {
          borderWidth: 1,
          borderColor: theme.colors.borderColorSix,
        }
      : {
          shadowColor: Colors.blackRGBA(0.16),
          shadowOffset: {
            width: 0,
            height: 2,
          },
          shadowRadius: 8,
          shadowOpacity: 1,
          elevation: 3,
        }),
  }),
  imageStyle: {
    alignSelf: 'center',
    marginTop: 16.8,
    marginBottom: 8,
    height: 250,
  },
  brandTextStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  nameTextStyle: {
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 31.2,
  },
  priceTextStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
    marginTop: 9,
    marginBottom: 15,
  },
  priceValueTextStyle: {
    ...Fonts.type.bold,
    fontSize: 18.7,
    lineHeight: 25,
  },
});
